export default defineNuxtRouteMiddleware(async (to) => {
  const { query, path } = to;
  const sessionId = query.session_id as string | undefined;
  if (!sessionId) return;

    // Remove session_id from URL
  if (process.client && typeof window !== 'undefined') {
    const url = new URL(window.location.href);
    url.searchParams.delete('session_id');
    window.location.replace(url.toString());
  }

  const auth = useAuth();
  try {
    // Verify session and fetch access token
    const { data: { access_token: accessToken } } = await $apiServer<{ data: { access_token: string } }>('/session/verify', {
      method: 'post',
      body: { session_id: sessionId, query_params: query },
    });

    const { data: user } = await $apiServer<{ data: any }>('/account/profile', {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    auth.setAccessToken(accessToken);
    auth.setUser(user);
  } catch (err) {
    console.error('Error during authentication:', err);
  }
});
